import { ApiClientBase } from "../framework/services/api-client-base";

class ShopInfoApiClientClass extends ApiClientBase {
  constructor() {
    super();

    this.host = window.location.origin;
  }

  protected acquireToken(): Promise<string> {
    return Promise.resolve('');
  }

  public getTermsOfService() {
    return this.get<string>('/terms-of-service.htm');
  }
}

export const ShopInfoApiClient = new ShopInfoApiClientClass();